export const ROUTES = {
  LOGIN: "/",
  HOME: "/home",
  REDIRECT:"/redirect",
};
